import { StateNode, Vec } from "@tldraw/editor";
class Dragging extends StateNode {
  static id = "dragging";
  static trackPerformance = true;
  initialCamera = new Vec();
  onEnter() {
    this.initialCamera = Vec.From(this.editor.getCamera());
    this.update();
  }
  onPointerMove() {
    this.update();
  }
  onPointerDown() {
    this.parent.transition("idle");
  }
  onPointerUp() {
    this.complete();
  }
  onInterrupt() {
    this.parent.transition("idle");
  }
  onCancel() {
    this.parent.transition("idle");
  }
  onComplete() {
    this.complete();
  }
  update() {
    const { initialCamera, editor } = this;
    const currentScreenPoint = editor.inputs.getCurrentScreenPoint();
    const originScreenPoint = editor.inputs.getOriginScreenPoint();
    const delta = Vec.Sub(currentScreenPoint, originScreenPoint).div(editor.getZoomLevel());
    if (delta.len2() === 0) return;
    editor.setCamera(initialCamera.clone().add(delta));
  }
  complete() {
    const { editor } = this;
    const pointerVelocity = editor.inputs.getPointerVelocity();
    const velocityAtPointerUp = Math.min(pointerVelocity.len(), 2);
    if (velocityAtPointerUp > 0.1) {
      this.editor.slideCamera({
        speed: velocityAtPointerUp,
        direction: { x: pointerVelocity.x, y: pointerVelocity.y, z: 0 }
      });
    }
    this.parent.transition("idle");
  }
}
export {
  Dragging
};
//# sourceMappingURL=Dragging.mjs.map
